type ChangeHandler = (value: string) => void;

interface Options {
  maxLength?: number;
  onChange: ChangeHandler;
}

export const trimAndCheck = (
  event: React.ChangeEvent<HTMLInputElement>,
  options: Options
) => {
  const { maxLength = Infinity, onChange } = options;
  const trimmedValue = event.currentTarget.value.trim();

  if (trimmedValue.length > maxLength) {
    return; // Prevent setting value if it exceeds max length
  }

  onChange(trimmedValue);
};